import { Box, Button, Checkbox, RadioGroup, RadioRow, Heading } from "@ogt/ui";
import { TrafficFilter } from "src/types/FormTypes";
import { TrafficInfoFilterDef } from "src/hooks/useTrafficInfoFilters";

export default function Filter({
  filters,
  value,
  onChange,
  onApply,
}: {
  filters: TrafficInfoFilterDef[];
  value: TrafficFilter;
  onChange: (next: TrafficFilter) => void;
  onApply: () => void;
}) {
  return (
    <Box noBorder>
      <Heading className="mb-4 flex items-center">
        Filtrera trafikinformation
      </Heading>

      <p className="mb-6">
        Filtrera för att se hur din resa påverkas. Välj trafikslag och om du
        vill se information för idag eller framåt.
      </p>

      <fieldset className="border-0 p-0 m-0">
        <legend className="mb-2 font-medium">Välj trafikslag</legend>
        <div className="flex gap-3 flex-wrap">
          {filters
            .filter((filter) => filter.Name !== "Skärgårdstrafik")
            .map((filter) => (
              <Checkbox
                labelClassName="w-full sm:w-auto"
                key={filter.Key}
                id={`traffic-mode-${filter.Key}`}
                checked={value.modes[filter.Key]}
                onCheckedChange={(checked) =>
                  onChange({
                    ...value,
                    modes: {
                      ...value.modes,
                      [filter.Key]: Boolean(checked),
                    },
                  })
                }
                withLabel
                variant="box"
              >
                {filter.Name}
              </Checkbox>
            ))}
        </div>
      </fieldset>
      <div className="mt-6 mb-6">
        <label
          id="time-label"
          className="block font-medium mb-2"
          htmlFor="time"
        >
          Gäller:
        </label>
        <RadioGroup
          id="time"
          aria-labelledby="time-label"
          orientation="horizontal"
          value={value.time}
          onValueChange={(time) =>
            onChange({
              ...value,
              time: time as TrafficFilter["time"],
            })
          }
        >
          <RadioRow value="today">Pågående</RadioRow>
          <RadioRow value="upcoming">Kommande</RadioRow>
        </RadioGroup>
      </div>

      <Button className="w-full sm:w-auto mt-0" onClick={onApply}>
        Filtrera
      </Button>
    </Box>
  );
}
